class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');

        if (!this.progressMeter) return;

        const targetPercent = parseFloat(this.dataset.progressPercent) || 0;
        const classLabel = this.getClassLabel(targetPercent);

        this.progressMeter.style.width = '0%';
        this.progressBar.classList.remove('progress-30', 'progress-60', 'progress-100', 'progress-free');

        setTimeout(() => {
            this.progressBar.classList.add(classLabel);
            this.progressMeter.style.width = `${targetPercent}%`;
        }, 100);
    }

    getClassLabel(percent) {
        if (percent === 0) return 'none';
        if (percent <= 30) return 'progress-30';
        if (percent <= 60) return 'progress-60';
        if (percent < 100) return 'progress-100';
        return 'progress-free';
    }
}

window.addEventListener('load', () => {
    customElements.define('free-shipping-component', FreeShippingMeter);
})
